var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0476 1.66602H0.952395C0.426443 1.66602 0 2.09243 0 2.61838V12.3803C0 12.9062 0.426443 13.3327 0.952395 13.3327H14.0476C14.5736 13.3327 15 12.9062 15 12.3803V2.61838C15 2.09243 14.5736 1.66602 14.0476 1.66602ZM14.0476 2.61838V9.5448L12.1707 7.83837C11.8886 7.58195 11.4547 7.59219 11.1852 7.86196L9.28566 9.76122L5.54024 5.28742C5.25713 4.94932 4.73855 4.946 4.45119 5.28004L0.952395 9.34624V2.61838H14.0476ZM10 5.11838C10 4.39505 10.5861 3.80885 11.3095 3.80885C12.0328 3.80885 12.619 4.39505 12.619 5.11838C12.619 5.84172 12.0329 6.42789 11.3095 6.42789C10.5862 6.42792 10 5.84172 10 5.11838Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto);
export default __webpack_public_path__ + "static/media/photo.ae4a60a2c976a62c0d8254f95833a547.svg";
export { ForwardRef as ReactComponent };